import styled from "styled-components";
import {MedicationAdministerProps} from "../MedicineAdministerDialog";
import {PatchApplicationDto} from "server-openapi";
import {Text} from "../../../../kit/Text";
import {DateUtils} from "../../../../core/utils/dateUtils";
import {Layout} from "../../../../kit/Layout";
import {NameValue} from "./PatchApplicationItems";
import {getPatchApplicationDescription} from "../../../../syncstream/utils/PatchApplicationUtils";
import React from "react";
import {useApiUtils} from "../../../../syncstream/utils/hooks/useApiUtils";

const ActivityBox = styled.div`
  border-style: solid;
  border-color: #c5bacb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
`;
const StatusBox = styled.div`
  background-color: rgba(246, 233, 254, 1);
  color: black;
  padding: 1.25rem;

  flex-direction: column;
  display: flex;
  width: 100%;
`;

export interface PatchApplicationSummaryBoxProps {
  patchApplication: PatchApplicationDto;
}
export function PatchApplicationSummaryBox(props: PatchApplicationSummaryBoxProps) {
  const userUtils = useApiUtils().users;
  return (
  <StatusBox>
    <Text weight={'bold'}>Current Status as at {DateUtils.toDisplayString(props.patchApplication.clientUpdatedAt)}</Text>
    <ActivityBox>
      <Layout>

        <NameValue name="Status">
          <span  style={{ color: "#B040F9" }}>PATCH </span> {getPatchApplicationDescription(userUtils, props.patchApplication.status, props.patchApplication.clientUpdatedAt, props.patchApplication.clientUser)}
        </NameValue>
        <NameValue name="Time">
          {DateUtils.toDisplayString(props.patchApplication.lastAppliedAt)} - {DateUtils.toDisplayString(DateUtils.toDate(props.patchApplication.scheduledEnd!))}
        </NameValue>
        <NameValue name="Applied to">
          {props.patchApplication.patchLocation?.description}
        </NameValue>
        {
            props.patchApplication.comment &&
            <NameValue name="Notes">
              {props.patchApplication.comment}
            </NameValue>
        }
      </Layout>
    </ActivityBox>
  </StatusBox>);

}
